import React, { useEffect, useState } from "react";
import { Container, Row } from "reactstrap";
import NaviFaqItems from "./NaviFaqItems";
import ObPfHoldingsBase from "./ObPfHoldingsBase";
import { getAllBonds } from "../services/waitlist-service";
import { toast } from "react-toastify";
import moment from "moment";

export default function MldHoldingsd(props) {
  const [isMld, setIsMld] = useState(false)
  const { isMobile } = props;

  const redirectToProduct = (product, productType) => {
      window.location.href = `/platform/#/biddeasy-asset/${productType}/${product}`;
  };

  useEffect(()=>{
    Object.keys(props.holdings).map((item)=>{
      props?.bondDetails?.filter((e) => e.product === item)[0]
                          ?.productType === "mld" && setIsMld(true)
    })
  },[])

  return (
    <>
      <Container
        style={
          props.isMobile ? { paddingLeft: "2px", paddingRight: "2px" } : {}
        }
      >
       {isMld && <p className="font-weight-semi-bold w-100 header">Market Linked Debentures</p>}
        {/* {isMld &&<div className='ribbon mb-4'>
          <img src={Ribbon} />
          <div className='text'>
            <p>The gains on MLDs get reflected in the Current Value field instead of the Coupons field.</p>
          </div>
        </div>} */}
        {!isMobile ? (
          Object.keys(props.holdings).map((item) => (
                props?.bondDetails?.filter((e) => e.product === item)[0]
                          ?.productType === "mld" &&
              <Row>
                {
                  <div className="holding-outer">
                    <ObPfHoldingsBase
                      title={
                        props?.bondDetails?.filter((e) => e.product === item)[0]
                          ?.issuer
                      }
                      img={
                        props?.bondDetails?.filter((e) => e.product === item)[0]
                          ?.logoUrl
                      }
                      firstCard={true}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Current Value"
                      value={(props.holdings[item].pfStats.mtm).oroNumber(2, true)}
                      isMobile={isMobile}
                      isRedemptionAllowed={(props?.bondDetails.find(e => e.product === item) || {}).isRedemptionAllowed}
                      productType={props?.holdings[item]?.productType}
                      productName={props?.holdings[item]?.product}
                    />

                    <ObPfHoldingsBase
                      title="Amount Invested"
                      value={props.holdings[item].pfStats.userInvestedAmnt ? (props.holdings[item].pfStats.userInvestedAmnt).oroNumber(2, true) : "₹0"}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Absolute Returns"
                      value={
                        Math.round(
                          props?.holdings[item]?.absoluteReturns * 100
                        ) / 100 + "%"
                      }
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Maturity Date"
                      value={
                        props.bondDetails.filter((e) => e.product === item).length ?
                          new moment(new Date(props.bondDetails.filter((e) => e.product === item)[0]
                            .maturityDate)).format("Do MMM YYYY") : null
                      }
                      isMobile={isMobile}
                    />
                    <span
                      className="view"
                      onClick={() => redirectToProduct(item, props.holdings[item].productType)}
                    >
                      View Details
                    </span>
                  </div>
                }
              </Row> 
          ))
          ) : (
            <div>
            {Object.keys(props.holdings).map((item) => (
              props?.bondDetails?.filter((e) => e.product === item)[0]
              ?.productType === "mld" &&
              <div>
                <div className="holding-outer">
                  <ObPfHoldingsBase
                    title={
                      props?.bondDetails?.filter((e) => e.product === item)[0]
                        ?.issuer
                    }
                    img={
                      props?.bondDetails?.filter((e) => e.product === item)[0]
                        ?.logoUrl
                    }
                    firstCard={true}
                    isMobile={isMobile}
                  />

                  <div className="hr"></div>

                  <div className="wrapper">
                    <ObPfHoldingsBase
                      title="Current Value"
                      value={(props.holdings[item].pfStats.mtm).oroNumber(2, true)}
                      isMobile={isMobile}
                      isRedemptionAllowed={(props?.bondDetails.find(e => e.product === item) || {}).isRedemptionAllowed}
                      productType={props?.holdings[item]?.productType}
                      productName={props?.holdings[item]?.product}
                    />

                    <ObPfHoldingsBase
                      title="Amount Invested"
                      value={props.holdings[item].pfStats.userInvestedAmnt ? (props.holdings[item].pfStats.userInvestedAmnt).oroNumber(2, true) : "₹0"}
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Absolute Returns"
                      value={
                        Math.round(
                          props?.holdings[item]?.absoluteReturns * 100
                        ) / 100 + "%"
                      }
                      isMobile={isMobile}
                    />
                    <ObPfHoldingsBase
                      title="Maturity Date"
                      value={
                        props.bondDetails.filter((e) => e.product === item).length ?
                          moment(new Date(props.bondDetails.filter((e) => e.product === item)[0]
                            .maturityDate)).format("Do MMM YYYY") : null
                      }
                      isMobile={isMobile}
                    />
                  </div>
                  <span className="view"
                    onClick={() => redirectToProduct(item, props.holdings[item].productType)}
                  >
                    View Details
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </Container>
    </>
  );
}
